/* eslint-disable no-extend-native */
// BEGIN polyfill_flatMap
/**
 * @see https://estada.ch/2019/6/10/javascript-arrayprototypeflatmap-polyfill/
 */
if (!Array.prototype.flatMap) {
  Object.defineProperty(Array.prototype, 'flatMap', {
    value: function <U, T, This = undefined> (callback: (this: This, value: T, index: number, array: T[]) => U | ReadonlyArray<U>, thisArg: This) {
      let self = thisArg || this;
      if (self === null) {
        throw new TypeError('Array.prototype.flatMap ' +
                'called on null or undefined');
      }
      if (typeof callback !== 'function') {
        throw new TypeError(callback +
                ' is not a function');
      }

      let list: U[] = [];

      // 1. Let O be ? ToObject(this value).
      let o = Object(self);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      let len = o.length >>> 0;

      for (let k = 0; k < len; ++k) {
        if (k in o) {
          let partList = callback.call(self, o[k], k, o);
          list = list.concat(partList);
        }
      }

      return list;
    },
  });
}
// END polyfill_flatMap
